import React from 'react';

export default class Thumbnail extends React.Component {
  render() {
    const alt = this.props.alt || '';
    return (
      <img
        alt={alt}
        style={{ maxWidth: 60, maxHeight: 60 }}
        src={this.props.img}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/thumbnail/Thumbnail.js